import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { Button, Collapse } from 'react-bootstrap';

import { Requisition } from '@customTypes/requisition';
import useRequisition from '@hooks/useRequisition';
import useViewportSizing from '@hooks/useViewportSizing';
import PatientDetailOrderContent from './expanded/PatientDetailOrderContent';
import PatientDetailOrderHeader from './PatientDetailOrderHeader';

import './PatientDetailOrder.scss';

/** Keep in sync with opacity transitions in PatientDetailOrder.scss, PatientDetailOrderProductPreview.scss, and Collapse timeout below */
const ORDER_DETAILS_COLLAPSE_MS = 200;

interface IProps {
  defaultIsCollapsed?: boolean;
  requisition: Requisition;
}

export default function PatientDetailOrder({ requisition, defaultIsCollapsed = false }: IProps) {
  const [open, setOpen] = useState<boolean>(!defaultIsCollapsed);
  const { isMobile } = useViewportSizing();
  const { isCompleted, canDowngrade, disableDowngradeOrder, orders } = useRequisition(requisition);

  return (
    <div className='patient-detail-order'>
      <div className={`patient-detail-order__header${open ? ' patient-detail-order__header--open' : ''}`}>
        <PatientDetailOrderHeader
          requisition={requisition}
          isMobile={isMobile}
          isCompleted={isCompleted}
          canDowngrade={canDowngrade}
          disableDowngradeOrder={disableDowngradeOrder}
        />

        <Button
          variant='ghost'
          aria-label={open ? 'Close section' : 'Open section'}
          aria-expanded={open}
          onClick={() => setOpen(o => !o)}
          className='patient-detail-order__toggle-button'
        >
          <FontAwesomeIcon icon={(open ? faChevronUp : faChevronDown) as IconDefinition} fontSize={20} />
        </Button>
      </div>

      <div className='patient-detail-order__preview-details-stack'>
        <Collapse in={open} timeout={ORDER_DETAILS_COLLAPSE_MS}>
          <div>
            <PatientDetailOrderContent requisition={requisition} orders={orders} orderOpen={open} />
          </div>
        </Collapse>
      </div>
    </div>
  );
}
